import React from 'react';
import LineChart from '../../charts/LineChart';
import BarChart from '../../charts/BarChart';
import PieChart from '../../charts/PieChart';
import BulletChart from '../../charts/BulletChart';
import './embeds.css';

const CHART_MAP = {
  line: LineChart,
  bar: BarChart,
  pie: PieChart,
  bullet: BulletChart,
};

const VALUE_FORMATTERS = {
  currency: (value) => '$' + Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 }),
  percent: (value) => Number(value).toLocaleString(undefined, { maximumFractionDigits: 1 }) + '%',
  number: (value) => Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 }),
};

function resolveFormatter(raw) {
  if (!raw) return null;
  if (typeof raw === 'function') return raw;
  return VALUE_FORMATTERS[raw] ?? null;
}

export default function ChartEmbed({ kind = 'line', data, options = {} }) {
  // Ensure options is not null and provide defaults
  const chartOptions = {
    kind: kind || 'line',
    data: data || [],
    colors: options.colors || null,
    height: options.height || 300,
    title: options.title || null,
    valueFormatter: resolveFormatter(options.valueFormatter),
    tooltipFormatter: options.tooltipFormatter || null,
    xLabel: options.xLabel || null,
    yLabel: options.yLabel || null,
    tickRotation: options.tickRotation || -45,
    showGrid: options.showGrid !== false, // default to true
    margin: options.margin || { top: 24, right: 24, bottom: 70, left: 80 },
    keys: options.keys || null, // BarChart specific
    indexBy: options.indexBy || null, // BarChart specific
  };
  
  const Comp = CHART_MAP[chartOptions.kind] || LineChart;
  
  return <Comp data={chartOptions.data} {...chartOptions} />;
}
